import SectionHeading from "./SectionHeading";
import { offeringCards } from "@/mocks/content";

export default function Offerings() {
  return (
    <section id="offerings" className="scroll-mt-20 bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="What We Collect"
          title="本站提供什么，一眼看清"
          desc="九七电影院把怀旧老片的线索分成四个方向，从片库、港片、年代到观看方式逐一展开，你可以从任意一个方向进入。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {offeringCards.map((card, index) => (
            <article
              key={card.title}
              className="group relative flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <span className="absolute top-5 right-5 font-heading text-2xl text-background-300">
                0{index + 1}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${card.icon} text-2xl`} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">
                {card.desc}
              </p>
              <ul className="mt-5 flex flex-wrap gap-2 border-t border-background-200 pt-4">
                {card.points.map((point) => (
                  <li
                    key={point}
                    className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}